var map = {
	"./add-circle.svg": "bc3d",
	"./add-colored.svg": "143b",
	"./arrow-right.svg": "f415",
	"./award.svg": "619e",
	"./briefcase.svg": "e75e",
	"./brifecase-tick.svg": "4c1d",
	"./buildings.svg": "b6f8",
	"./camera.svg": "5712",
	"./clipboard.svg": "3f57",
	"./cloud-connection.svg": "f2c0",
	"./crown.svg": "f71c",
	"./cup.svg": "5c17",
	"./devices.svg": "7bdc",
	"./document-text.svg": "eae2",
	"./document-upload.svg": "9909",
	"./external-drive.svg": "1c8d",
	"./flag.svg": "e1c0",
	"./flash.svg": "ab72",
	"./ghost.svg": "bc74",
	"./info-circle.svg": "960c",
	"./keyboard-open.svg": "a635",
	"./layer.svg": "dc09",
	"./link-square.svg": "b702",
	"./location.svg": "ac4d",
	"./lock.svg": "4ce0",
	"./messages.svg": "5ce0",
	"./microphone.svg": "fdf4",
	"./mobile.svg": "906e",
	"./monitor-mobile.svg": "e166",
	"./notice-period.svg": "b4b2",
	"./pen-tool-2.svg": "4435",
	"./people.svg": "0520",
	"./personalcard.svg": "755f",
	"./recovery-convert.svg": "b0da",
	"./refresh.svg": "95ba",
	"./reset.svg": "1686",
	"./ruler&pen.svg": "0bd3",
	"./salary.svg": "195a",
	"./send.svg": "ed77",
	"./simcard.svg": "0f15",
	"./sms.svg": "d937",
	"./star.svg": "263f",
	"./trash.svg": "badf",
	"./triangle.svg": "0658",
	"./user-octagon.svg": "34d9",
	"./video-circle.svg": "2430"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ee5";